import { createContext, useContext, useSyncExternalStore } from 'react';

// Estado global do painel de artefato: um só painel por página, aberto pelo
// cartão da mensagem ou pelo evento SSE `artifact` (sem passar props pelo
// Playground inteiro).

/** De onde o conteúdo vem: o dono (logado) ou uma conversa compartilhada. */
export type ArtifactSource = { kind: 'owner' } | { kind: 'conversation'; shareId: string };

export interface ArtifactRef {
  artifactId: string;
  title: string;
  artifactType: string;
  version?: number;
  source: ArtifactSource;
}

interface ViewerState {
  ref: ArtifactRef | null;
  // Incrementa a cada abertura: o painel refaz o fetch mesmo para o mesmo id/versão.
  nonce: number;
}

let state: ViewerState = { ref: null, nonce: 0 };
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((l) => l());
}

export function openArtifact(ref: ArtifactRef) {
  state = { ref, nonce: state.nonce + 1 };
  emit();
}

export function closeArtifact() {
  if (!state.ref) return;
  state = { ref: null, nonce: state.nonce + 1 };
  emit();
}

export function getOpenArtifact(): ArtifactRef | null {
  return state.ref;
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useArtifactViewer(): ViewerState {
  return useSyncExternalStore(subscribe, () => state, () => state);
}

/** Origem dos artefatos renderizados na árvore (conversa compartilhada vs. dono). */
export const ArtifactSourceContext = createContext<ArtifactSource>({ kind: 'owner' });
export const useArtifactSource = () => useContext(ArtifactSourceContext);
